import { cn } from '../../lib/utils.ts';
import { Button, type ButtonProps } from './button.tsx';

/** A list's on/off quick filter ("Mine", "Open only"), tinted while on. */
export function ToggleButton({
  pressed,
  label,
  className,
  ...props
}: Omit<ButtonProps, 'children'> & { pressed: boolean; label: string }) {
  return (
    <Button
      variant="outline"
      size="sm"
      aria-pressed={pressed}
      className={cn(pressed && 'border-brand bg-brand/10 text-foreground', className)}
      {...props}
    >
      {label}
    </Button>
  );
}
